import type { Command } from '../../types';
import type { IShape, ShapeTransform } from '../shapes/interfaces/IShape';

export class TransformShapes implements Command {
    private readonly transforms: Array<{
        shape: IShape;
        oldTransform: ShapeTransform;
        newTransform: ShapeTransform;
    }>;

    constructor(transforms: Array<{
        shape: IShape;
        oldTransform: ShapeTransform;
        newTransform: ShapeTransform;
    }>) {
        this.transforms = transforms;
    }

    execute(): void {
        this.transforms.forEach(item => item.shape.setTransform(item.newTransform));
    }

    undo(): void {
        this.transforms.forEach(item => item.shape.setTransform(item.oldTransform));
    }
}
